/**
 * Sidra znotraj iste strani (npr. <a href="/#izbor-okusov">) z upoštevanjem sticky headerja.
 *
 * Brskalnik ob skoku na #id postavi element na vrh viewporta, kjer ga prekrije
 * #stickyHeader. Tukaj od položaja odštejemo višino headerja:
 * .section-sponsors + .horizontal-scroll-nav (pasica) + .main-nav.
 *
 * Ker je header position: sticky (ostane v toku dokumenta), je ciljni scrollY
 * = vrh cilja − TRENUTNA višina headerja, ne glede na to, ali se bo header med
 * scrollom skrčil (header-menu.js): skrčenje za N px premakne tudi cilj za N px
 * navzgor, zato se razlika izniči.
 *
 * - klik na sidro → gladek scroll (razen pri prefers-reduced-motion), URL se posodobi
 *   s pushState (brez privzetega skoka), cilj dobi fokus (dostopnost)
 * - nalaganje strani s #hash in hashchange (nazaj/naprej) → takojšen popravek položaja
 * - preskoči povezave, ki jih vodijo druge komponente (data-toggle, role=tab)
 *   ali imajo data-no-anchor-scroll
 */

const OFFSET_SELECTORS = ['.section-sponsors', '.horizontal-scroll-nav', '.main-nav']

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

function headerOffset() {
	const root = document.getElementById('stickyHeader') || document
	return OFFSET_SELECTORS.reduce((sum, selector) => {
		const el = root.querySelector(selector)
		return sum + (el ? el.getBoundingClientRect().height : 0)
	}, 0)
}

function targetFromHash(hash) {
	if (!hash || hash === '#') return null
	let id
	try {
		id = decodeURIComponent(hash.slice(1))
	} catch (e) {
		id = hash.slice(1)
	}
	return document.getElementById(id) || document.querySelector('a[name="' + CSS.escape(id) + '"]')
}

function isSamePageAnchor(link) {
	return (
		link.hash !== '' &&
		link.origin === window.location.origin &&
		link.pathname === window.location.pathname &&
		link.search === window.location.search
	)
}

// html ima scroll-behavior: smooth → za takojšen skok ga začasno izklopi
function scrollToY(y, smooth) {
	const html = document.documentElement
	if (smooth && !reduceMotion.matches) {
		window.scrollTo({ top: y, behavior: 'smooth' })
		return
	}
	const prev = html.style.scrollBehavior
	html.style.scrollBehavior = 'auto'
	window.scrollTo(0, y)
	html.style.scrollBehavior = prev
}

function scrollToTarget(target, smooth) {
	const top = target.getBoundingClientRect().top + window.scrollY - headerOffset()
	scrollToY(Math.max(0, Math.round(top)), smooth)
}

function focusTarget(target) {
	if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1')
	target.focus({ preventScroll: true })
}

export default {
	init() {
		// klik na sidro znotraj iste strani
		document.addEventListener('click', (e) => {
			if (e.defaultPrevented || e.button !== 0) return
			if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return

			const link = e.target.closest('a[href]')
			if (!link || !isSamePageAnchor(link)) return
			if (link.target && link.target !== '_self') return
			if (link.hasAttribute('data-toggle') || link.hasAttribute('data-bs-toggle')) return
			if (link.getAttribute('role') === 'tab' || link.hasAttribute('data-no-anchor-scroll')) return

			const target = targetFromHash(link.hash)
			if (!target) return

			e.preventDefault()
			if (window.location.hash !== link.hash) {
				history.pushState(null, '', link.hash)
			}
			scrollToTarget(target, true)
			focusTarget(target)
		})

		// nalaganje strani z #hash: brskalnik skoči sam, tukaj popravimo za header
		const correct = () => {
			const target = targetFromHash(window.location.hash)
			if (target) scrollToTarget(target, false)
		}
		if (window.location.hash) {
			window.addEventListener('load', () => requestAnimationFrame(correct), { once: true })
		}
		window.addEventListener('hashchange', () => requestAnimationFrame(correct))
	}
}
